import PaystackLogo from '../assets/img/paystacklogo.png';
import SquadCoLogo from '../assets/img/squacologo.png';
import OfflinePaymentImg from '../assets/img/offlinepayment.jpeg';

export const rolesPerCategory = {
  1: ['COORDINATOR'],
  2: ['SYSTEM ADMINISTRATOR'],
  3: ['FIELD OPERATOR'],
};

export const facilityReportingModals = {
  STANDARD_QUARTERS: 'STANDARD_QUARTERS',
  STANDARD_MEASUREMENTS: 'STANDARD_MEASUREMENTS',
  STANDARD_PARAMETERS: 'STANDARD_PARAMETERS',
};

export const reportTypes = {
  QAQC: 'QAQC',
  NORMAL: 'NORMAL',
};

export const reportStatuses = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  APPROVED: 'APPROVED',
  SUBMITTED: 'SUBMITTED',
  REJECTED: 'REJECTED',
};

export const userCategories = [
  {
    id: 2,
    name: 'EDM',
  },
  {
    id: 1,
    name: 'REGULATOR',
  },
  {
    id: 3,
    name: 'CONSULTANT',
  },
  {
    id: 4,
    name: 'PERSONNEL',
  },
  //'REGULATOR', 'EDM', 'CONSULTANT'
];

export const userCats = {
  EDM: 'EDM',
  REGULATOR: 'REGULATOR',
  CONSULTANT: 'CONSULTANT',
  PERSONNEL: 'PERSONNEL',
};

export const offlinePaymentChannels = [
  { value: 'REMITA', label: 'REMITA' },
  { value: 'BANK', label: 'BANK' },
];

export const paymentOptionsList = [
  {
    method: 'ONLINE',
    gateway: 'PAYSTACK',
    desc: 'Pay with Paystack',
    color: 'midnightblue',
    bg: PaystackLogo,
  },
  {
    method: 'ONLINE',
    gateway: 'GTPAY',
    desc: 'Pay with Squad',
    color: 'midnightblue',
    bg: SquadCoLogo,
  },
  {
    method: 'OFFLINE',
    gateway: 'OFFLINE',
    desc: 'Pay Offline',
    color: '',
    bg: OfflinePaymentImg,
  },
];

export const invoiceStatusList = [
  { label: 'All Status', value: '' },
  { label: 'Open', value: 'open' },
  { label: 'Ongoing', value: 'ongoing' },
  { label: 'Closed', value: 'closed' },
];

export const activityStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  INACTIVE: 'INACTIVE',
};

export const quarters = [
  {
    value: 0,
    label: 'Quarter 1',
  },
  {
    value: 1,
    label: 'Quarter 2',
  },
  {
    value: 2,
    label: 'Quarter 3',
  },
  {
    value: 3,
    label: 'Quarter 4',
  },
];
